import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import { COMPACT_HOTEL_CARD_MIN_HEIGHT, COMPACT_HOTEL_CARD_IMAGE_HEIGHT } from './CarouselOfferCardStyles'

export const Card = styled(Sheet)`
  min-height: ${rem(COMPACT_HOTEL_CARD_MIN_HEIGHT)};
  height: 100%;
  overflow: hidden;
`

export const Hero = styled.div`
  position: relative;
  z-index: 2;
  height: ${rem(COMPACT_HOTEL_CARD_IMAGE_HEIGHT)};
  flex-shrink: 0;
  overflow: hidden;
`

export const Content = styled(Sheet)`
  flex: 1;
  display: flex;
  flex-direction: column;
`
